export const RPC_DASHBOARD_ENDPOINTS = {
    SUMMARY: "/get_influencer_dashboard_summary",
};
